(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }
  const updateVariantImages = (root = document) => {
  const cards = [];

  if (root.matches?.('.product-grid__item[data-variant-image]')) {
    cards.push(root);
  }

  cards.push(...(root.querySelectorAll?.('.product-grid__item[data-variant-image]') || []));

  cards.forEach((card) => {
    const image = card.querySelector('.card-gallery img');
    const imageUrl = card.getAttribute('data-variant-image');

    if (!image || !imageUrl) return;

    image.removeAttribute('srcset');
    image.removeAttribute('data-srcset');

    const picture = image.closest('picture');
    if (picture) {
      picture.querySelectorAll('source').forEach((source) => source.remove());
    }

    image.src = imageUrl;
  });
};

updateVariantImages();

const variantImageObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === 1) updateVariantImages(node);
    });
  });
});

variantImageObserver.observe(document.body, { childList: true, subtree: true });

  } catch(e) { console.error(e); }
})();
})();
